const getDatatablesLanguage = function() {
  return {
    processing: __('Processing'),
    search: __('Search'),
    lengthMenu: __('Show :MENU elements', { menu: '_MENU_'}),
    info: __('Showing :START to :END of :TOTAL entries', {
      start: '_START_',
      end: '_END_',
      total: '_TOTAL_',
    }),
    infoEmpty: __('Showing 0 to 0 of 0 entries'),
    infoFiltered: __('(filtered from :MAX total entries)', { max: '_MAX_'}),
    infoPostFix:    '',
    loadingRecords: __('Loading...'),
    zeroRecords: __('None to display'),
    emptyTable: __('No data available'),
    paginate: {
      first: __('First'),
      previous: __('Previous'),
      next: __('Next'),
      last: __('Last'),
    },
    aria: {
      sortAscending: __(': activate to sort column ascending'),
      sortDescending: __(': activate to sort column descending'),
    },
    select: {
      rows: __(':total rows selected', { total: '%d' }),
    },
  }
}

export { getDatatablesLanguage }
